import { render } from "./ModalCredit.vue?vue&type=template&id=4acec4fe&scoped=true"
import script from "./ModalCredit.vue?vue&type=script&lang=js"
export * from "./ModalCredit.vue?vue&type=script&lang=js"

import "./ModalCredit.vue?vue&type=style&index=0&id=4acec4fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acec4fe"]])

export default __exports__